<template>
    <div>
      <NavBar></NavBar>
      <div class="text-center mb-2">
        <h5>{{ this.$store.state.chartMw.displayName }}</h5>
        <button class="btn buttonStyle" type="button" data-bs-toggle="collapse" data-bs-target="#tradingPanel">
            Show/Hide Panel
        </button>
    </div>
      <div class=" text-center container collapse" id="tradingPanel">
        <div class="btn-group" role="group" v-if="!this.$store.state.toasts.length">
            <button class="btn btn-success " @click="openBuySell('BUY')">Buy</button>
            <button class="btn btn-secondary" @click="redirect()">Back</button>
            <button class="btn btn-danger"  @click="openBuySell('SELL')">Sell</button>

        </div>
        <div class="d-flex justify-content-center gap-3 mb-3">
        <!-- <div class="col-md-6">
            <label for="scriptSelect" class="form-label">Script:</label>
        </div> -->

        <div>
            <label for="timeFrameSelect" class="form-label mb-0"><small>Time Frame</small></label>
            <select class="form-select form-select-sm" id="timeFrameSelect" style="width: 120px;"  @change="handleTimeFrameChange">
                <option value="_5MIN">5m</option>
                <option value="_15MIN">15m</option>
                <option value="_1HR" selected>1h</option>
            </select>
        </div>
      </div>
      </div>
      <div  ><div ref="chartContainer" id="chart-container" ></div></div>
    </div>
  </template>

<script>
// import { createChart } from 'lightweight-charts' // TradingView lightweight-charts library
import { getChart } from '@/service/restService'
import NavBar from '@/components/main/NavBar.vue'
export default {
  name: 'Chart',
  components: {
    NavBar
  },
  data () {
    return {
      chart: null,
      candleSeries: null,
      lastCandle: null,
      interval: null,
      timeSplit: 3600
    }
  },
  mounted () {
    this.initializeChart()
    this.fetchInitialData('_1HR')
    // this.setupWebSocket()
    window.addEventListener('resize', this.adjustChartSize)
  },
  beforeDestroy () {
    clearInterval(this.interval)
    if (this.chart) {
      this.chart.remove() // Removes the chart instance
      this.chart = null
    }
  },
  methods: {
    handleTimeFrameChange (event) {
      const selectedValue = event.target.value
      if (selectedValue === '_5MIN') { this.timeSplit = 300 } else if (selectedValue === '_15MIN') { this.timeSplit = 900 } else if (selectedValue === '_1HR') { this.timeSplit = 3600 }
      this.fetchInitialData(selectedValue)
      // Add logic to update state or fetch data
    },
    initializeChart () {
      // Create the chart instance
      this.chart = window.LightweightCharts.createChart(this.$refs.chartContainer, {
        // width: this.$refs.chartContainer.clientWidth,
        // height: this.$refs.chartContainer.clientHeight,
        layout: {
          backgroundColor: '#1e1e2f', // Dark background
          textColor: '#e0e0e0' // Light text
        },
        grid: {
          vertLines: {
            color: '#3b3b5c' // Subtle vertical grid lines
          },
          horzLines: {
            color: '#3b3b5c' // Subtle horizontal grid lines
          }
        },
        crosshair: {
          mode: 0 // Magnet crosshair mode
        },
        timeScale: {
          timeVisible: true,
          secondsVisible: false,
          borderColor: '#3b3b5c' // Border color for time scale
        }
      })

      // Create a candle series for OHLC data
      this.candleSeries = this.chart.addCandlestickSeries({
        upColor: '#26a69a', // Green for upward candles
        downColor: '#ef5350', // Red for downward candles
        borderUpColor: '#26a69a',
        borderDownColor: '#ef5350',
        wickUpColor: '#FFFFFF',
        wickDownColor: '#FFFFFF'
      })
    },
    async fetchInitialData (time) {
      try {
        // Replace with your REST API URL
        var data = null
        getChart(this.$store.state.chartMw.instrumentToken, time).then((response) => {
          data = response.data
          const formattedData = data.map((item) => ({
            time: this.convertToTimestamp(item.timeStamp),
            open: item.open,
            high: item.high,
            low: item.low,
            close: item.close
          }))

          // Set the initial chart data
          this.candleSeries.setData(formattedData)
          this.lastCandle = data[data.length - 1]
          this.lastCandle.time = this.convertToTimestamp(this.lastCandle.timeStamp)
          if (this.interval) {
            clearInterval(this.interval)
          }
          var self = this
          this.interval = setInterval(() => this.readPrice(this.$store.state.chartMw.instrumentToken, self), 1000)
          // this.readPrice('256265', self)
        }).catch((error) => {
          console.log(error.response.data.message[0])
        })

        // Map REST API data to the format required by TradingView
      } catch (error) {
        console.error('Error fetching initial data:', error)
      }
    },
    openBuySell: function (type) {
      this.$store.commit('setBuySell', {'type': type, 'mw': this.$store.state.chartMw})
    },
    redirect: function () {
      if (this.isMobile()) {
        this.$router.push('/mw')
      } else {
        this.$router.push('/orders')
      }
    },
    readPrice (token, self) {
      // console.log(token)
      // console.log(this.$store.state.ticker[token])
      this.handleWebSocketData(this.$store.state.ticker[token])
    },
    handleWebSocketData (tickData) {
      // console.log(tickData)
      const price = tickData
      const tickTime = Math.floor(Date.now() / 1000) + 5 * 60 * 60 + 30 * 60// Get current timestamp in seconds
      const candleTime = tickTime - (tickTime % this.timeSplit) // Round to nearest 5-minute mark

      // console.log('candle time:' + candleTime + ' last candle time :' + this.lastCandle.time)
      // console.log('price:' + price)
      // console.log(this.lastCandle.time)
      if (!this.lastCandle || candleTime > this.lastCandle.time) {
        // If new 5-minute interval starts, create a new candle
        // console.log('new candle')
        this.lastCandle = { time: candleTime, open: price, high: price, low: price, close: price }
        this.candleSeries.update(this.lastCandle)
      } else {
        // Update existing candle
        this.lastCandle.high = Math.max(this.lastCandle.high, price)
        this.lastCandle.low = Math.min(this.lastCandle.low, price)
        this.lastCandle.close = price
        // console.log(this.lastCandle)
        this.candleSeries.update(this.lastCandle)
      }
    },
    convertToTimestamp (dateTime) {
      if (!dateTime || typeof dateTime !== 'string') {
        console.error('Invalid dateTime input:', dateTime)
        return Math.floor(Date.now() / 1000) // Return current timestamp as fallback
      }

      const [date, time] = dateTime.split(' ')
      if (!date || !time) {
        console.error('Incorrect date format:', dateTime)
        return Math.floor(Date.now() / 1000)
      }

      const [day, month, year] = date.split('-')
      const [hours, minutes] = time.split(':')

      if (!day || !month || !year || !hours || !minutes) {
        console.error('Incomplete date components:', dateTime)
        return Math.floor(Date.now() / 1000)
      }

      // Create UTC timestamp using Date.UTC()
      return Math.floor(Date.UTC(year, month - 1, day, hours, minutes) / 1000) // Convert to seconds
    },
    adjustChartSize () {
      // Dynamically calculate chart height to fit the window
      const container = this.$refs.chartContainer
      const availableHeight = window.innerHeight - container.getBoundingClientRect().top - 20 // 20px padding
      const availableWidth = container.clientWidth

      container.style.height = `${availableHeight}px`

      if (this.chart) {
        this.chart.resize(availableWidth, availableHeight)
      }
    }
  }
}
</script>

<style scoped>
#chart-container {
  width: 100%;
  height: 600px;
  border-radius: 8px; /* Rounded edges */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Classy shadow effect */
}
.buttonStyle {
  margin: 1px;
  align-items: center;
  padding: 1px;
  border: 1px solid var(--bs-border-color);
  background-color: var(--bs-body-bg);
  color: var(--bs-body-color);
  font-weight: bold;
  width:  300px;
  height: 30px;
}
.buttonStyle:hover {
  background-color: var(--bs-tertiary-bg);
}
</style>



// WEBPACK FOOTER //
// src/components/chart/Chart.vue